import axios from 'axios';

import routes from 'app/routes';

export default {
  create: (values, onSuccess, onError) => {
    axios
      .post(
        routes.api.super_admins.prompts.create,
        values,
      )
      .then((_resp) => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data);
      });
  },

  update: (promptId, values, onSuccess, onError) => {
    axios
      .patch(
        routes.api.super_admins.prompts.update(promptId),
        values,
      )
      .then((_resp) => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data);
      });
  },

  destroy: (promptId, onSuccess) => {
    axios
      .delete(routes.api.super_admins.prompts.destroy(promptId))
      .then((_resp) => {
        onSuccess();
      });
  },
};
